import React from "react";
import { RadixLoading } from "../primitives/RadixLoading";
export var StateInitializationLoading = function (_a) {
    var label = _a.label, wrapperClassName = _a.wrapperClassName, mainClassName = _a.mainClassName, sectionClassName = _a.sectionClassName, _b = _a.ariaLabel, ariaLabel = _b === void 0 ? "Loading" : _b;
    return (React.createElement("div", { className: wrapperClassName },
        React.createElement("main", { className: mainClassName, "aria-label": ariaLabel },
            React.createElement("section", { className: sectionClassName, "aria-live": "polite" },
                React.createElement(RadixLoading, { label: label })))));
};
